import initialState from './initialState';
import actionTypes from './actionTypes';

const transactionReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_BR_RECORDS_SUCCESS:
            return {
                ...state,
                brExceptions: action.payload,
            };
        default:
            return state;
    }
};

export default transactionReducer;
